import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { SortIcon, Table, TableModule } from 'primeng/table';
import {
  MaestroConfig,
  MaestroFieldConfig,
} from '../../../../core/models/intranet-maestro';
import { AlertaService } from '../../../../core/services/alerta.service';
import { IntranetMantenedoresService, TipoVehiculoIconoCatalogo } from '../../../../core/services/intranet-mantenedores.service';
import { LoadingService } from '../../../../core/services/loading.service';
import { StorageService } from '../../../../core/services/storage.service';
import { CampoVehiculoConfig, CampoVehiculoGlobal, IntranetVehiculoCamposService } from '../../../../core/services/intranet-vehiculo-campos.service';

@Component({
  selector: 'app-tipos-vehiculo-page',
  templateUrl: './tipos-vehiculo.component.html',
  styleUrl: './tipos-vehiculo.component.scss',
  imports: [CommonModule, FormsModule, ButtonModule, DialogModule, InputTextModule, TableModule, SortIcon],
})
export class TiposVehiculoComponent implements OnInit {
  @ViewChild('tablaCamposGlobales') tablaCamposGlobales?: Table;
  readonly config: MaestroConfig = {
    key: 'tipos-vehiculo',
    titulo: 'Tipos de vehículo',
    singular: 'tipo de vehículo',
    endpoint: 'tipos-vehiculo',
    idKey: 'id',
    fields: [
      { key: 'descripcion', label: 'Descripción', type: 'text', required: true },
      { key: 'categoria', label: 'Categoría', type: 'select', required: true },
      { key: 'icono', label: 'Icono en la aplicación', type: 'select', required: true },
      { key: 'precio', label: 'Precio', type: 'decimal' },
    ],
    columns: [
      { key: 'id', label: 'ID tipo de vehículo' },
      { key: 'descripcion', label: 'Descripción' },
      { key: 'categoria', label: 'Categoría' },
      { key: 'icono', label: 'Icono' },
      { key: 'precio', label: 'Precio', type: 'money' },
      { key: 'camposConfigurados', label: 'Campos', type: 'status' },
    ],
  };
  items: Record<string, any>[] = [];
  visibleDialog = false;
  guardando = false;
  subiendoIcono = false;
  visibleIconosDialog = false;
  cargandoIconos = false;
  iconosCatalogo: TipoVehiculoIconoCatalogo[] = [];
  errorIconos = '';
  mensajeIconos = '';
  registro: Record<string, any> = {};
  visibleCamposDialog = false;
  tipoCampos: Record<string, any> | null = null;
  camposVehiculo: CampoVehiculoConfig[] = [];
  cargandoCampos = false;
  guardandoCampos = false;
  errorCampos = '';
  visibleCamposGlobalesDialog = false;
  camposGlobales: CampoVehiculoGlobal[] = [];
  busquedaCamposGlobales = '';
  cargandoCamposGlobales = false;
  guardandoCampoGlobal: number | null = null;
  errorCamposGlobales = '';
  readonly seccionesCampos = [
    { id: 1, titulo: 'Datos del vehículo' },
    { id: 2, titulo: 'Características' },
    { id: 3, titulo: 'Documentos' },
  ];
  readonly categoriasVehiculo = [
    { id: 'MAQUINARIA', descripcion: 'Maquinaria y volquetes' },
    { id: 'FLETE', descripcion: 'Fletes' },
  ];

  constructor(
    private readonly mantenedoresService: IntranetMantenedoresService,
    private readonly vehiculoCamposService: IntranetVehiculoCamposService,
    private readonly storageService: StorageService,
    private readonly alertaService: AlertaService,
    private readonly loadingService: LoadingService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.inicializarFormulario();
    this.cargarDatos();
  }

  get tituloDialogo(): string {
    const id = this.registro?.[this.config.idKey];
    return id ? `Editar ${this.config.singular}` : `Nuevo ${this.config.singular}`;
  }

  abrirNuevo(): void {
    this.inicializarFormulario();
    this.visibleDialog = true;
  }

  editar(item: Record<string, any>): void {
    this.registro = {
      ...item,
      activo: Number(item['activo'] ?? 1),
    };
    this.visibleDialog = true;
    this.cdr.detectChanges();
  }

  iconoPreview(item: Record<string, any>): string {
    return item['iconoUrl'] || `assets/vehiculo-iconos/${item['icono'] || 'ic_maq1'}.svg`;
  }

  abrirSelectorIconos(): void {
    this.visibleIconosDialog = true;
    this.iconosCatalogo = [];
    this.errorIconos = '';
    this.mensajeIconos = '';
    this.cargandoIconos = true;
    this.mantenedoresService.listarIconosTipoVehiculo().subscribe({
      next: (response) => {
        this.cargandoIconos = false;
        if (response.isSuccess) this.iconosCatalogo = response.value ?? [];
        else this.errorIconos = response.message || 'No se pudieron cargar los iconos.';
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.cargandoIconos = false;
        this.errorIconos = error.message ?? 'No se pudieron cargar los iconos.';
        this.cdr.detectChanges();
      },
    });
  }

  seleccionarIcono(icono: TipoVehiculoIconoCatalogo): void {
    this.registro['icono'] = icono.codigo || 'ic_maq1';
    this.registro['iconoUrl'] = icono.url;
    this.visibleIconosDialog = false;
  }

  iconoCatalogoPreview(icono: TipoVehiculoIconoCatalogo): string {
    return icono.url || `assets/vehiculo-iconos/${icono.codigo}.svg`;
  }

  iconoSeleccionado(icono: TipoVehiculoIconoCatalogo): boolean {
    return icono.url
      ? this.registro['iconoUrl'] === icono.url
      : !this.registro['iconoUrl'] && this.registro['icono'] === icono.codigo;
  }

  async subirIcono(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (!file) return;
    if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) {
      this.alertaService.openAlerta('Alerta', 'Selecciona una imagen PNG, JPG o WEBP.', 'warn');
      return;
    }
    if (file.size < 512 || file.size > 1024 * 1024) {
      this.alertaService.openAlerta('Alerta', 'El icono debe pesar entre 512 bytes y 1 MB.', 'warn');
      return;
    }
    this.subiendoIcono = true;
    this.cdr.detectChanges();
    try {
      const { width, height } = await this.leerDimensiones(file);
      if (width < 64 || width > 1024 || height < 64 || height > 1024) {
        this.subiendoIcono = false;
        this.alertaService.openAlerta('Alerta', 'El icono debe medir entre 64 y 1024 píxeles por lado.', 'warn');
        this.cdr.detectChanges();
        return;
      }
    } catch {
      this.subiendoIcono = false;
      this.alertaService.openAlerta('Alerta', 'No se pudo leer la imagen seleccionada.', 'warn');
      this.cdr.detectChanges();
      return;
    }
    this.mantenedoresService.subirIconoTipoVehiculo(file).subscribe({
      next: (response) => {
        this.subiendoIcono = false;
        if (response.isSuccess && response.value?.idIcono) {
          const iconoSubido = response.value;
          this.iconosCatalogo = [iconoSubido, ...this.iconosCatalogo.filter((icono) => icono.idIcono !== iconoSubido.idIcono)];
          this.mensajeIconos = 'Icono subido. Selecciónalo en la cuadrícula.';
        } else {
          this.alertaService.openAlerta('Error', response.message || 'No se pudo subir el icono.', 'error');
        }
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.subiendoIcono = false;
        this.alertaService.openAlerta('Error', error.message ?? 'No se pudo subir el icono.', 'error');
        this.cdr.detectChanges();
      },
    });
  }

  private leerDimensiones(file: File): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const image = new Image();
      image.onload = () => {
        URL.revokeObjectURL(url);
        resolve({ width: image.naturalWidth, height: image.naturalHeight });
      };
      image.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('Imagen no válida'));
      };
      image.src = url;
    });
  }

  abrirCampos(item: Record<string, any>): void {
    const idTipoVehiculo = Number(item['id']);
    this.tipoCampos = item;
    this.camposVehiculo = [];
    this.errorCampos = '';
    this.cargandoCampos = true;
    this.visibleCamposDialog = true;
    this.vehiculoCamposService.obtener(idTipoVehiculo).subscribe({
      next: (respuesta) => {
        if (Number(this.tipoCampos?.['id']) !== idTipoVehiculo || !this.visibleCamposDialog) return;
        this.cargandoCampos = false;
        if (respuesta.isSuccess) this.camposVehiculo = respuesta.value ?? [];
        else this.errorCampos = respuesta.message;
        this.cdr.detectChanges();
      },
      error: () => {
        if (Number(this.tipoCampos?.['id']) !== idTipoVehiculo || !this.visibleCamposDialog) return;
        this.cargandoCampos = false;
        this.errorCampos = 'No se pudieron cargar los campos de este tipo de vehículo.';
        this.cdr.detectChanges();
      },
    });
  }

  abrirCamposGlobales(): void {
    this.busquedaCamposGlobales = '';
    this.tablaCamposGlobales?.clear();
    this.visibleCamposGlobalesDialog = true;
    this.cargarCamposGlobales();
  }

  filtrarCamposGlobales(texto: string): void {
    this.busquedaCamposGlobales = texto;
    this.tablaCamposGlobales?.filterGlobal(texto, 'contains');
  }

  confirmarVisibilidadGlobal(campo: CampoVehiculoGlobal): void {
    const ocultar = Number(campo.activo) === 1;
    this.alertaService.openAlertaDesicion(
      ocultar ? 'Ocultar campo' : 'Mostrar campo',
      ocultar
        ? `¿Ocultar "${campo.descripcion}" en todos los tipos de vehículo? Los datos ya registrados se conservarán.`
        : `¿Volver a mostrar "${campo.descripcion}"? Se recuperará la configuración de cada tipo de vehículo.`,
      'warn',
      () => this.cambiarVisibilidadGlobal(campo.idCampo, ocultar ? 0 : 1),
    );
  }

  private cambiarVisibilidadGlobal(idCampo: number, activo: number): void {
    if (this.guardandoCampoGlobal !== null) return;
    this.guardandoCampoGlobal = idCampo;
    this.vehiculoCamposService.cambiarVisibilidadGlobal(idCampo, activo).subscribe({
      next: (respuesta) => {
        this.guardandoCampoGlobal = null;
        if (respuesta.isSuccess) {
          this.camposGlobales = this.camposGlobales.map((campo) =>
            campo.idCampo === idCampo ? { ...campo, activo } : campo,
          );
        }
        this.alertaService.openAlerta(
          respuesta.isSuccess ? 'Correcto' : 'Error',
          respuesta.message,
          respuesta.isSuccess ? 'success' : 'error',
        );
        this.cdr.detectChanges();
      },
      error: () => {
        this.guardandoCampoGlobal = null;
        this.alertaService.openAlerta('Error', 'No se pudo actualizar la visibilidad del campo.', 'error');
        this.cdr.detectChanges();
      },
    });
  }

  private cargarCamposGlobales(): void {
    this.camposGlobales = [];
    this.errorCamposGlobales = '';
    this.cargandoCamposGlobales = true;
    this.vehiculoCamposService.listarGlobal().subscribe({
      next: (respuesta) => {
        if (!this.visibleCamposGlobalesDialog) return;
        this.cargandoCamposGlobales = false;
        if (respuesta.isSuccess) this.camposGlobales = respuesta.value ?? [];
        else this.errorCamposGlobales = respuesta.message;
        this.cdr.detectChanges();
      },
      error: () => {
        if (!this.visibleCamposGlobalesDialog) return;
        this.cargandoCamposGlobales = false;
        this.errorCamposGlobales = 'No se pudo cargar el catálogo de campos.';
        this.cdr.detectChanges();
      },
    });
  }

  camposDeSeccion(seccion: number): CampoVehiculoConfig[] {
    return this.camposVehiculo.filter((campo) => campo.seccion === seccion);
  }

  nombreSeccion(seccion: number): string {
    return this.seccionesCampos.find((item) => item.id === Number(seccion))?.titulo ?? 'Otra sección';
  }

  guardarCampos(): void {
    if (!this.tipoCampos || !this.camposVehiculo.length || this.guardandoCampos) return;
    const idTipoVehiculo = Number(this.tipoCampos['id']);
    this.guardandoCampos = true;
    this.vehiculoCamposService.guardar(idTipoVehiculo, this.camposVehiculo).subscribe({
      next: (respuesta) => {
        this.guardandoCampos = false;
        if (respuesta.isSuccess) {
          this.visibleCamposDialog = false;
          this.cargarDatos();
        }
        this.alertaService.openAlerta(
          respuesta.isSuccess ? 'Correcto' : 'Error',
          respuesta.message,
          respuesta.isSuccess ? 'success' : 'error',
        );
        this.cdr.detectChanges();
      },
      error: () => {
        this.guardandoCampos = false;
        this.alertaService.openAlerta('Error', 'No se pudo guardar la configuración de campos.', 'error');
        this.cdr.detectChanges();
      },
    });
  }

  guardar(): void {
    if (this.subiendoIcono || this.guardando) return;
    const campoFaltante = this.config.fields.find(
      (field) =>
        field.required &&
        (this.registro[field.key] === null ||
          this.registro[field.key] === undefined ||
          this.registro[field.key] === ''),
    );

    if (campoFaltante) {
      this.alertaService.openAlerta(
        'Alerta',
        `El campo ${campoFaltante.label} es obligatorio`,
        'warn',
      );
      return;
    }

    this.guardando = true;
    this.loadingService.open('Guardando registro...');

    this.mantenedoresService.guardar(this.config.endpoint, this.buildPayload()).subscribe({
      next: (response) => {
        this.loadingService.close();
        this.guardando = false;

        if (!response.isSuccess) {
          this.alertaService.openAlerta('Alerta', response.message, 'error');
          return;
        }

        this.visibleDialog = false;
        this.alertaService.openAlerta('Correcto', response.message, 'success');
        this.cargarDatos();
      },
      error: (error) => {
        this.loadingService.close();
        this.guardando = false;
        this.alertaService.openAlerta('Error', error.message ?? 'No se pudo guardar', 'error');
      },
    });
  }

  confirmarEliminar(item: Record<string, any>): void {
    this.alertaService.openAlertaDesicion(
      'Eliminar registro',
      `¿Deseas eliminar ${item['descripcion'] ?? 'este registro'}?`,
      'warn',
      () => {
        void this.eliminar(item);
      },
    );
  }

  getValorCelda(item: Record<string, any>, key: string): string {
    const value = item[key];
    if (key === 'categoria') {
      return this.categoriasVehiculo.find((opcion) => opcion.id === value)?.descripcion ?? String(value ?? '-');
    }
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    return String(value);
  }

  formatearMoneda(value: unknown): string {
    return Number(value ?? 0).toFixed(2);
  }

  fieldOptions(field: MaestroFieldConfig): Array<{ id: number | string; descripcion: string }> {
    if (field.key === 'categoria') return this.categoriasVehiculo;
    return [];
  }

  trackByLabel(_index: number, item: any): string {
    return item.label;
  }

  private cargarDatos(): void {
    this.loadingService.open('Cargando registros...');
    this.mantenedoresService.listar(this.config.endpoint).subscribe({
      next: (response) => {
        this.loadingService.close();
        if (!response.isSuccess) {
          this.alertaService.openAlerta('Alerta', response.message, 'error');
          this.items = [];
          this.cdr.detectChanges();
          return;
        }
        this.items = response.value ?? [];
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.loadingService.close();
        this.items = [];
        this.cdr.detectChanges();
        this.alertaService.openAlerta('Error', error.message ?? 'No se pudo cargar', 'error');
      },
    });
  }

  private inicializarFormulario(): void {
    this.registro = {
      activo: 1,
      precio: 0,
      categoria: null,
      icono: null,
      iconoUrl: null,
    };
  }

  private async eliminar(item: Record<string, any>): Promise<void> {
    const id = Number(item[this.config.idKey]);
    return await new Promise((resolve) => {
      this.loadingService.open('Eliminando registro...');
      this.mantenedoresService.eliminar(this.config.endpoint, id).subscribe({
        next: (response) => {
          this.loadingService.close();
          if (response.isSuccess) {
            this.alertaService.openAlerta('Correcto', response.message, 'success');
            this.cargarDatos();
          } else {
            this.alertaService.openAlerta('Alerta', response.message, 'error');
          }
          resolve();
        },
        error: (error) => {
          this.loadingService.close();
          this.alertaService.openAlerta('Error', error.message ?? 'No se pudo eliminar', 'error');
          resolve();
        },
      });
    });
  }

  private buildPayload(): Record<string, unknown> {
    const usuario = this.storageService.storageGet<any>('usuario');
    const payload: Record<string, unknown> = {};

    for (const field of this.config.fields) {
      const value = this.registro[field.key];
      payload[field.key] = field.type === 'checkbox' ? (value ? 1 : 0) : value;
    }

    payload['iconoUrl'] = this.registro['iconoUrl'] || null;

    payload['activo'] = Number(this.registro['activo'] ?? 1);

    if (this.registro[this.config.idKey]) {
      payload['id'] = Number(this.registro[this.config.idKey]);
    } else if (usuario?.idIntranetUsuario) {
      payload['idUsuarioCreacion'] = Number(usuario.idIntranetUsuario);
    }

    return payload;
  }
}
